import { atom } from "recoil";

export const isBarcodeLoading = atom({
  key: "isBarcodeLoading",
  default: false,
});
